import { EsigningProviderAuthenticationModeSlug, } from 'shared/domains/apollo/generated/types';
const AUTH_MODE_ORDER = {
    [EsigningProviderAuthenticationModeSlug.Email]: 0,
    [EsigningProviderAuthenticationModeSlug.SmsOtp]: 1,
    [EsigningProviderAuthenticationModeSlug.SweBankid]: 2,
    [EsigningProviderAuthenticationModeSlug.Freja]: 3,
    [EsigningProviderAuthenticationModeSlug.NorBankid]: 4,
    [EsigningProviderAuthenticationModeSlug.FinBankid]: 5,
    [EsigningProviderAuthenticationModeSlug.SmartId]: 6,
    [EsigningProviderAuthenticationModeSlug.Mitid]: 7,
    [EsigningProviderAuthenticationModeSlug.Unsupported]: 8,
};
export const sortAuthenticationModes = (authenticationModes) => [...authenticationModes].sort((a, b) => {
    const aOrder = AUTH_MODE_ORDER[a.slug];
    const bOrder = AUTH_MODE_ORDER[b.slug];
    if (aOrder !== bOrder) {
        if (aOrder === undefined)
            return 1;
        if (bOrder === undefined)
            return -1;
        return aOrder - bOrder;
    }
    return a.slug.localeCompare(b.slug);
});
